module.exports = {
	routesData: () => {
		return [
			{
				'ESCAPE TITANIUM 4X4 FHEV AZUL METÁLICO': 'spins/EscapeHibrida/AzulMetalico',
				'ESCAPE TITANIUM 4X4 FHEV BLANCO PLATINO': 'spins/EscapeHibrida/BlancoPlatino',
				'ESCAPE TITANIUM 4X4 FHEV ROJO METÁLICO': 'spins/EscapeHibrida/RojoMetalico',
				'ESCAPE TITANIUM 4X4 FHEV GRIS CARBÓN': 'spins/EscapeHibrida/GrisCarbon',
				'ESCAPE TITANIUM 4X4 FHEV PLATA PURO': 'spins/EscapeHibrida/PlataPuro',
				'ESCAPE TITANIUM 4X4 FHEV NEGRO AGATA': 'spins/EscapeHibrida/NegroAgata',

				'ESCAPE ECOBOOST ROJO METÁLICO': 'spins/EscapeEcoboost/RojoLucido',
				'ESCAPE ECOBOOST AZUL METÁLICO': 'spins/EscapeEcoboost/AzulMetalico',
				'ESCAPE ECOBOOST ARENA PERLADA': 'spins/EscapeEcoboost/ArenaPerlada',
				'ESCAPE ECOBOOST NEGRO AGATA': 'spins/EscapeEcoboost/NegroAgata',
				'ESCAPE ECOBOOST GRIS MAGNETICO': 'spins/EscapeEcoboost/GrisMagnetico',
				'ESCAPE ECOBOOST PLATA SOLAR': 'spins/EscapeEcoboost/PlataSolar',
				'ESCAPE ECOBOOST BLANCO ARTICO': 'spins/EscapeEcoboost/BlancoArtico',

				'ESCAPE SE 4X2 FHEV AZUL METÁLICO': 'spins/EscapeSE/AzulMetalico',
				'ESCAPE SE 4X2 FHEV BLANCO PLATINO': 'spins/EscapeSE/BlancoPlatino',
				'ESCAPE SE 4X2 FHEV ROJO METÁLICO': 'spins/EscapeSE/RojoMetalico',
				'ESCAPE SE 4X2 FHEV GRIS CARBÓN': 'spins/EscapeSE/GrisCarbon',
				'ESCAPE SE 4X2 FHEV PLATA PURO': 'spins/EscapeSE/PlataPuro',
				'ESCAPE SE 4X2 FHEV NEGRO AGATA': 'spins/EscapeSE/NegroAgata',

				'ESCAPE SEL 4X2 FHEV AZUL METÁLICO': 'spins/EscapeSEL/AzulMetalico',
				'ESCAPE SEL 4X2 FHEV BLANCO PLATINO': 'spins/EscapeSEL/BlancoPlatino',
				'ESCAPE SEL 4X2 FHEV ROJO METÁLICO': 'spins/EscapeSEL/RojoMetalico',
				'ESCAPE SEL 4X2 FHEV GRIS CARBÓN': 'spins/EscapeSEL/GrisCarbon',
				'ESCAPE SEL 4X2 FHEV PLATA PURO': 'spins/EscapeSEL/PlataPuro',
				'ESCAPE SEL 4X2 FHEV NEGRO AGATA': 'spins/EscapeSEL/NegroAgata',

				'BRONCO SPORT WILDTRAK AZUL GLACIAR': 'spins/BroncoWT/AzulGlaciar',
				'BRONCO SPORT WILDTRAK BLANCO OXFORD': 'spins/BroncoWT/BlancoOxford',
				'BRONCO SPORT WILDTRAK ROJO METÁLICO': 'spins/BroncoWT/RojoMetalico',
				'BRONCO SPORT WILDTRAK GRIS CARBÓN': 'spins/BroncoWT/GrisCarbon',
				'BRONCO SPORT WILDTRAK PLATA PURO': 'spins/BroncoWT/PlataPuro',
				'BRONCO SPORT WILDTRAK NEGRO SOMBRA': 'spins/BroncoWT/NegroSombra',
				'BRONCO SPORT WILDTRAK NARANJA METÁLICO': 'spins/BroncoWT/NaranjaMetalico',

				'BRONCO SPORT BIG BEND AZUL METÁLICO': 'spins/BroncoBB/AzulMetalico',
				'BRONCO SPORT BIG BEND BLANCO OXFORD': 'spins/BroncoBB/BlancoOxford',
				'BRONCO SPORT BIG BEND ROJO METÁLICO': 'spins/BroncoBB/RojoMetalico',
				'BRONCO SPORT BIG BEND GRIS CARBÓN': 'spins/BroncoBB/GrisCarbon',
				'BRONCO SPORT BIG BEND PLATA PURO': 'spins/BroncoBB/PlataPuro',
				'BRONCO SPORT BIG BEND NEGRO SOMBRA': 'spins/BroncoBB/NegroSombra',

				'BRONCO SPORT OUTER BANKS AZUL METÁLICO': 'spins/BroncoOB/AzulMetalico',
				'BRONCO SPORT OUTER BANKS GRIS HIELO': 'spins/BroncoOB/GrisHielo',
				'BRONCO SPORT OUTER BANKS GRIS CARBÓN': 'spins/BroncoOB/GrisCarbon',
				'BRONCO SPORT OUTER BANKS PLATA PURO': 'spins/BroncoOB/PlataPuro',

				'EDGE SEL AZUL OXFORD': 'spins/EdgeSEL/AzulOxford',
				'EDGE SEL BLANCO PLATINO': 'spins/EdgeSEL/BlancoPlatino',
				'EDGE SEL ROJO METÁLICO': 'spins/EdgeSEL/RojoMetalico',
				'EDGE SEL GRIS CARBÓN': 'spins/EdgeSEL/GrisCarbon',
				'EDGE SEL PLATA PURO': 'spins/EdgeSEL/PlataPuro',
				'EDGE SEL NEGRO AGATA': 'spins/EdgeSEL/NegroAgata',

				'EDGE ST AZUL PERFORMANCE': 'spins/EdgeST/AzulPerformance',
				'EDGE ST BLANCO PLATINO': 'spins/EdgeST/BlancoPlatino',
				'EDGE ST ROJO METÁLICO': 'spins/EdgeST/RojoMetalico',
				'EDGE ST GRIS CARBÓN': 'spins/EdgeST/GrisCarbon',
				'EDGE ST PLATA PURO': 'spins/EdgeST/PlataPuro',
				'EDGE ST NEGRO AGATA': 'spins/EdgeST/NegroAgata',

				'EXPLORER XLT AZUL OXFORD': 'spins/ExplorerXLT/AzulOxford',
				'EXPLORER XLT BLANCO PLATINO': 'spins/ExplorerXLT/BlancoPlatino',
				'EXPLORER XLT ROJO METÁLICO': 'spins/ExplorerXLT/RojoMetalico',
				'EXPLORER XLT GRIS MAGNETICO': 'spins/ExplorerXLT/GrisMagnetico',
				'EXPLORER XLT PLATA PURO': 'spins/ExplorerXLT/PlataPuro',
				'EXPLORER XLT NEGRO AGATA': 'spins/ExplorerXLT/NegroAgata',

				'EXPLORER LIMITED AZUL OXFORD': 'spins/ExplorerLimited/AzulOxford',
				'EXPLORER LIMITED BLANCO PLATINO': 'spins/ExplorerLimited/BlancoPlatino',
				'EXPLORER LIMITED ROJO METÁLICO': 'spins/ExplorerLimited/RojoMetalico',
				'EXPLORER LIMITED GRIS MAGNETICO': 'spins/ExplorerLimited/GrisMagnetico',
				'EXPLORER LIMITED PLATA PURO': 'spins/ExplorerLimited/PlataPuro',
				'EXPLORER LIMITED NEGRO AGATA': 'spins/ExplorerLimited/NegroAgata',

				'EXPLORER ST AZUL OXFORD': 'spins/ExplorerST/AzulOxford',
				'EXPLORER ST BLANCO PLATINO': 'spins/ExplorerST/BlancoPlatino',
				'EXPLORER ST ROJO METÁLICO': 'spins/ExplorerST/RojoMetalico',
				'EXPLORER ST GRIS CARBÓN': 'spins/ExplorerST/GrisCarbon',
				'EXPLORER ST PLATA PURO': 'spins/ExplorerST/PlataPuro',
				'EXPLORER ST NEGRO AGATA': 'spins/ExplorerST/NegroAgata',

				'EXPEDITION LIMITED GRIS MAGNETICO': 'spins/ExpeditionLimited/GrisMagnetico',
				'EXPEDITION LIMITED PLATA PURO': 'spins/ExpeditionLimited/PlataPuro',
				'EXPEDITION LIMITED NEGRO AGATA': 'spins/ExpeditionLimited/NegroAgata',

				'MUSTANG MACH 1 BLANCO OXFORD': 'spins/MustangMach1/BlancoOxford',
				'MUSTANG MACH 1 GRIS ACERO': 'spins/MustangMach1/GrisAcero',
				'MUSTANG MACH 1 NARANJA METÁLICO': 'spins/MustangMach1/NaranjaMetalico',
				'MUSTANG MACH 1 NEGRO PROFUNDO': 'spins/MustangMach1/NegroProfundo',

				'MUSTANG GT PREMIUM AZUL GALACTICO': 'spins/MustangGT/AzulGalactico',
				'MUSTANG GT PREMIUM GRIS CARBÓN': 'spins/MustangGT/GrisCarbon',
				'MUSTANG GT PREMIUM ROJO RALLY': 'spins/MustangGT/RojoRally',

				'RANGER XL AZUL RELAMPAGO': 'spins/RangerXL/AzulRelampago',
				'RANGER XL BLANCO ARTICO': 'spins/RangerXL/BlancoArtico',
				'RANGER XL GRIS MAGNETICO': 'spins/RangerXL/GrisMagnetico',
				'RANGER XL NEGRO PERLADO': 'spins/RangerXL/NegroPerlado',
				'RANGER XL PLATA METÁLICO': 'spins/RangerXL/PlataMetalico',
				'RANGER XL ROJO RUBI': 'spins/RangerXL/RojoRubi',

				'RANGER XLS DIESEL AZUL RELAMPAGO': 'spins/RangerXLSDiesel/AzulRelampago',
				'RANGER XLS DIESEL BLANCO ARTICO': 'spins/RangerXLSDiesel/BlancoArtico',
				'RANGER XLS DIESEL GRIS MAGNETICO': 'spins/RangerXLSDiesel/GrisMagnetico',
				'RANGER XLS DIESEL NEGRO PERLADO': 'spins/RangerXLSDiesel/NegroPerlado',
				'RANGER XLS DIESEL PLATA METÁLICO': 'spins/RangerXLSDiesel/PlataMetalico',
				'RANGER XLS DIESEL ROJO RUBI': 'spins/RangerXLSDiesel/RojoRubi',

				'RANGER RAPTOR AZUL RELAMPAGO': 'spins/RangerRaptor/AzulPerformance',
				'RANGER RAPTOR BLANCO ARTICO': 'spins/RangerRaptor/BlancoArtico',
				'RANGER RAPTOR GRIS PIEDRA': 'spins/RangerRaptor/GrisPiedra',
				'RANGER RAPTOR NEGRO ABSOLUTO': 'spins/RangerRaptor/NegroAbsoluto',
				'RANGER RAPTOR NARANJA METÁLICO': 'spins/RangerRaptor/NaranjaMetalico',

				'F-150 LARIAT SPORT AZUL GALACTICO': 'spins/F150Lariat/AzulGalactico',
				'F-150 LARIAT SPORT BLANCO OXFORD': 'spins/F150Lariat/BlancoOxford',
				'F-150 LARIAT SPORT GRIS CARBÓN': 'spins/F150Lariat/GrisCarbon',
				'F-150 LARIAT SPORT ROJO MAGNETICO': 'spins/F150Lariat/RojoMetalico',

				'F-150 XLT FHEV PLATA PURO': 'spins/F150XLT/PlataPuro',
				'F-150 XLT FHEV GRIS CARBÓN': 'spins/F150XLT/GrisCarbon',
				'F-150 XLT FHEV BLANCO OXFORD': 'spins/F150XLT/BlancoOxford',
				'F-150 XLT FHEV ROJO METÁLICO': 'spins/F150XLT/RojoMetalico',

				'F-150 PLATINUM FHEV AZUL METÁLICO': 'spins/F150PlatinumHEV/AzulMetalico',
				'F-150 PLATINUM FHEV NEGRO AGATA': 'spins/F150PlatinumHEV/NegroAgata',
				'F-150 PLATINUM FHEV PLATA PURO': 'spins/F150PlatinumHEV/PlataPuro',
				'F-150 PLATINUM FHEV GRIS CARBÓN': 'spins/F150PlatinumHEV/GrisCarbon',

				'F-150 RAPTOR GRIS AZULADO': 'spins/F150Raptor/GrisAzulado',
				'F-150 RAPTOR BLANCO AVALANCHE': 'spins/F150Raptor/BlancoAvalanche',
				'F-150 RAPTOR GRIS PIEDRA': 'spins/F150Raptor/GrisPiedra',
				'F-150 RAPTOR NARANJA METÁLICO': 'spins/F150Raptor/NaranjaMetalico',
				'F-150 RAPTOR NEGRO AGATA': 'spins/F150Raptor/NegroAgata',

				'RANGER FX4 BLANCO ARTICO': 'spins/RangerFX4/BlancoArtico',
				'RANGER FX4 GRIS MAGNETICO': 'spins/RangerFX4/GrisMagnetico',
				'RANGER FX4 NEGRO PERLADO': 'spins/RangerFX4/NegroPerlado',
				'RANGER FX4 PLATA METÁLICO': 'spins/RangerFX4/PlataMetalico',
				'RANGER FX4 ROJO RUBI': 'spins/RangerFX4/RojoRubi',

				'RANGER LIMITED AZUL RELAMPAGO': 'spins/RangerLimited/AzulRelampago',
				'RANGER LIMITED BLANCO ARTICO': 'spins/RangerLimited/BlancoArtico',
				'RANGER LIMITED GRIS MAGNETICO': 'spins/RangerLimited/GrisMagnetico',
				'RANGER LIMITED NEGRO PERLADO': 'spins/RangerLimited/NegroPerlado',
				'RANGER LIMITED PLATA METÁLICO': 'spins/RangerLimited/PlataMetalico',
				'RANGER LIMITED ROJO RUBI': 'spins/RangerLimited/RojoRubi',

				'RANGER LIMITED BLACK EDITION NEGRO NOCHE': 'spins/RangerLimitedBlackEdition/',

				'RANGER XL CHASIS BLANCO ARTICO': 'spins/RangerXLChasis/BlancoArtico',
				'RANGER XL CHASIS PLATA METÁLICO': 'spins/RangerXLChasis/PlataMetalico',

				'RANGER XLT AZUL RELAMPAGO': 'spins/RangerXLT/AzulRelampago',
				'RANGER XLT BLANCO ARTICO': 'spins/RangerXLT/BlancoArtico',
				'RANGER XLT GRIS MAGNETICO': 'spins/RangerXLT/GrisMagnetico',
				'RANGER XLT NEGRO PERLADO': 'spins/RangerXLT/NegroPerlado',
				'RANGER XLT PLATA METÁLICO': 'spins/RangerXLT/PlataMetalico',
				'RANGER XLT ROJO RUBI': 'spins/RangerXLT/RojoRubi',
			},
		];
	},
};
